<p-multiselect
  [focusOnHover]="!isLargeList"
  [appendTo]="appendTo()"
  [ngClass]="{
    'm-multiselect m-checkbox': true,
    'is-draggable': isDraggable,
    'ng-invalid': !isValid,
  }"
  [filter]="filter"
  [filterBy]="filterBy"
  [filterPlaceHolder]="filterPlaceHolder"
  [group]="group"
  [maxSelectedLabels]="maxSelectedLabels"
  [selectionLimit]="selectionLimit"
  [scrollHeight]="scrollHeight"
  [virtualScroll]="virtualScroll"
  [virtualScrollItemSize]="virtualScrollItemSize"
  [(ngModel)]="value"
  (ngModelChange)="onModelChange($event)"
  (onChange)="onChange.emit($event)"
  [options]="options"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [name]="name()"
  [display]="display"
  [showToggleAll]="showToggleAll"
  [styleClass]="styleClass"
  (onPanelShow)="handlePanelShow()"
  [placeholder]="placeholder()"
  [selectedItemsLabel]="selectedItemsLabel"
  [style]="{ width: width, height: height }"
  [panelStyle]="panelStyle"
  [panelStyleClass]="
    panelStyleClass +
    ' m-multiselect-panel' +
    (isLargeList ? ' m-multiselect-optimized' : '')
  "
  (onPanelHide)="onPanelHide.emit($event)"
  [disabled]="$disabled()">
  <!-- Show tooltip for dropdown items with labels at/above LABEL_TRUNCATE_LIMIT characters -->
  <ng-template let-option pTemplate="item">
    @let optionText = getOptionLabel(option);
    @if (optionText?.length >= LABEL_TRUNCATE_LIMIT) {
      <m-tooltip [content]="optionText" position="right">
        <span>
          {{ optionText | ellipsis: LABEL_TRUNCATE_LIMIT }}
        </span>
      </m-tooltip>
    } @else {
      <span>{{ optionText }}</span>
    }
  </ng-template>

  <!-- Forward consumer-projected footer into the inner p-multiselect via ngTemplateOutlet, since inherited @ContentChildren won't reach the inner instance. -->
  @if (_footerTemplate) {
    <ng-template pTemplate="footer">
      <ng-container [ngTemplateOutlet]="_footerTemplate"></ng-container>
    </ng-template>
  }
</p-multiselect>
